import styled from "styled-components";

const CustomToastNotification = ({ data, toastProps }) => {
  const isColored = toastProps.theme === "colored";

  return (
    <Wrapper className="d-flex flex-column w-100">
      <h3
        className={`
          font-16 font-semibold
          ${isColored ? "text-white" : "text-dark"}
        `}
      >
        {data.title}
      </h3>
      <p
        className={`
          font-15 capitalize-first
          ${isColored ? "text-white" : "text-lighter-black"}
        `}
      >
        {data.content}
      </p>
    </Wrapper>
  );
};

export default CustomToastNotification;

const Wrapper = styled.div`
  .capitalize-first::first-letter {
    text-transform: capitalize;
  }
`;
